import React, { useState, useEffect } from "react";
import NumberInputSimple from "./NumberInputSimple";
import Lock from "./Lock";

const PaddingSettings = ({
  label = i18n.t('indents'),
  onChange,
  node,
  bottom,
  left,
  lock,
  right,
  top
}) => {
  const update = (field, value) => {
    value = value.toString();
    if (!field || node[lock]) {
      return onChange({
        [top]: value,
        [right]: value,
        [left]: value,
        [bottom]: value
      });
    }

    onChange(field, value);
  };

  return (
    <div className="eb-padding form-group">
      <div className="eb-padding__header">
        <label className="ng-binding">{label}</label>
        <div className="eb-padding__reset">
          {[0, 5, 10].map((value, index) => (
            <a key={index} onClick={() => update(null, value)}>
              {value}
            </a>
          ))}
        </div>
      </div>
      <div className="eb-padding__group">
        <div className="eb-padding__top">
          <div className="eb-padding__side">
            <NumberInputSimple
              value={node[top]}
              onChange={value => update(top, value)}
            />
          </div>
        </div>
        <div className="eb-padding__middle">
          <div className="eb-padding__side">
            <NumberInputSimple
              value={node[left]}
              onChange={value => update(left, value)}
            />
          </div>
          <Lock value={node[lock]} onChange={value => onChange(lock, value)} />
          <div className="eb-padding__side">
            <NumberInputSimple
              value={node[right]}
              onChange={value => update(right, value)}
            />
          </div>
        </div>
        <div className="eb-padding__bottom">
          <div className="eb-padding__side">
            <NumberInputSimple
              value={node[bottom]}
              onChange={value => update(bottom, value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaddingSettings;
